import React from 'react';

import { LINK_BLUE } from '../../../foundation/config/colors';
import { GenotypeVariant } from '../redux/types';

export const getSampleVariantColumns = (navigate: (path: string) => void) => [
  {
    title: 'Variant ID',
    dataIndex: 'variant_id',
    key: 'variant_id',
    render: (_: any, record: GenotypeVariant) => (
      <a
        href={`/variant-workflow/${record.variant_id}/clinical_observation`}
        style={{ color: LINK_BLUE }}
        onClick={(e) => {
          e.preventDefault();
          window.open(
            `/variant-workflow/${record.variant_id}/clinical_observation`,
            '_blank',
          );
        }}
      >
        {`${record.transcript_external_id}(${record.gene_symbol}):${record.cdna}(${record.protein_change})`}
      </a>
    ),
  },
  {
    title: 'Classification',
    dataIndex: 'clinical_interpretation',
    key: 'clinical_interpretation',
    render: (clinical_interpretation: string) => (
      <span>{clinical_interpretation || 'to be classified'}</span>
    ),
  },
];
